import { createContext } from 'react';

export interface MindmapInteractionState {
  onToggleExpand: (nodeId: string) => void;
  selectedNodeId: string | null;
  onSelectNode: (nodeId: string | null) => void;
  hoveredNodeId: string | null;
  highlightedNodeIds: Set<string>;
  isEntranceComplete: boolean;
}

const EMPTY_HIGHLIGHTED_NODE_IDS = new Set<string>();

const EMPTY_INTERACTION_STATE: MindmapInteractionState = {
  onToggleExpand: () => undefined,
  selectedNodeId: null,
  onSelectNode: () => undefined,
  hoveredNodeId: null,
  highlightedNodeIds: EMPTY_HIGHLIGHTED_NODE_IDS,
  isEntranceComplete: true,
};

export const MindmapInteractionContext = createContext<MindmapInteractionState>(EMPTY_INTERACTION_STATE);
